/**
 * Überprüft, ob der Pass auf das aktuelle Event angewendet werden kann.
 *
 * @param {Pass} pass - Der Pass des Benutzers.
 * @param {EventiveEvent} eventData - Das Event, für das geprüft wird, ob der Pass anwendbar ist.
 * @returns {boolean} - Gibt zurück, ob der Pass anwendbar ist oder nicht.
 */
export function isPassApplicableToEvent(pass, eventData) {
  // Überprüfe, ob der Pass aktiv ist
  if (!pass.is_active) {
    return false;
  }
  // Überprüfe, ob der Pass Event-spezifisch ist (event_bucket muss übereinstimmen)
  if (pass.event_bucket !== eventData.event_bucket) {
    return false;
  }

  // Gehe durch die Pass-Regeln und überprüfe jede Regel
  const passRules = pass.pass_bucket.rules;

  for (const rule of passRules) {
    // Überprüfe, ob die Regel auf das Event zutrifft
    const isTargetEvent = rule.target.ticket_bucket === '*' || rule.target.ticket_bucket === eventData.ticket_buckets[0].id;

    if (!isTargetEvent) {
      continue;  // Diese Regel ist für dieses Event nicht anwendbar
    }

    // Überprüfe Nutzungsbeschränkungen (Anzahl der verbleibenden Nutzungen)
    // const remainingUses = pass.preview_available_ticket_uses.remaining;
    // if (remainingUses === 0) {
    //   return false;  // Keine verbleibenden Nutzungen
    // }

    // Überprüfe, ob gleichzeitige Verwendungen erlaubt sind
    // if (rule.restrictions.uses?.disallow_concurrent && pass.uses.length > 0) {
    //   return false;  // Gleichzeitige Verwendung nicht erlaubt und bereits benutzt
    // }

    // Falls die Regel das Ticket billiger macht, kann der Pass angewendet werden
    if (rule.result.price.percent_off || rule.result.price.cents_off) {
      return true;
    }
  }

  return false;  // Falls keine Regeln anwendbar sind
}

/**
 * Überprüft alle Pässe eines Benutzers für ein Event und gibt an, ob einer der Pässe verwendet werden kann.
 *
 * @param {Object<UserGlobalPasses>} userGlobalPasses - Eine Liste der Pässe des Benutzers.
 * @param {EventiveEvent} eventData  - Das aktuelle Event, für das die Pässe überprüft werden.
 * @returns {Array} - Eine Liste der anwendbaren Pässe für das Event.
 */
export function getApplicablePassesForEvent(userGlobalPasses, eventData) {
  return userGlobalPasses?.passes ? userGlobalPasses.passes.filter(pass => isPassApplicableToEvent(pass, eventData)) : [];
}
